/** Common prefixes found in AI-generated search suggestions. */
export const SUGGESTION_PREFIXES: readonly string[] = [
  "Trouve moi les ",
  "Trouve moi des ",
  "Trouve-moi les ",
  "Trouve-moi des ",
  "Trouve les ",
  "Find me the ",
  "Find me ",
  "Find the ",
];

/**
 * Strips known suggestion prefixes from a query string
 * and capitalizes the first character of the remaining text.
 */
export function stripSuggestionPrefix(query: string): string {
  for (const prefix of SUGGESTION_PREFIXES) {
    if (query.toLowerCase().startsWith(prefix.toLowerCase())) {
      const stripped = query.slice(prefix.length);
      return stripped.charAt(0).toUpperCase() + stripped.slice(1);
    }
  }
  return query;
}
